<fieldset [ngClass]="{'align-top': $safeNavigationMigration(values?.length) > 0}">
  <label [ngClass]="{'text-multiline-labeltop' : $safeNavigationMigration(values?.length) > 0 }" for="{{aid}}"
    [ngClass]="{ 'ultra-tight-label': ultraTightLabel }">
    @if (iconClass) {
      <span><i [ngClass]="iconClass"></i>&nbsp;
    </span>
    }<span>{{label}}</span>
    @if (infoText) {
      <rask-info>{{infoText}}</rask-info>
    }
    @if (infoTemplate) {
      <rask-info><ng-container [ngTemplateOutlet]="infoTemplate"></ng-container></rask-info>
    }
  </label>
  <div id="{{aid}}" class="text-multiline middle-align"
    [ngClass]="{ 'bold-text': boldText, 'tight-label': tightLabel, 'ultra-tight-label': ultraTightLabel }">
    @if (value) {
      <span>{{value}}@if (value) {
        <br />
      }</span>
    }
    @if (values) {
      <div>
        @for (value of values; track value) {
          <div>
            @if (value) {
              <span>{{value}}<br /></span>
            }
          </div>
        }
      </div>
    }
    @if (nullIndicator === true && (!value || value === '') && (!values || values?.length === 0)) {
      <div>---</div>
    }
    <ng-content>
    </ng-content>
  </div>
</fieldset>